export const OPEN_INSPECTOR =
  "documentSmartTextInspector/OPEN_INSPECTOR" as const;
export const OPEN_CREATE = "documentSmartTextInspector/OPEN_CREATE" as const;
export const CLOSE_INSPECTOR =
  "documentSmartTextInspector/CLOSE_INSPECTOR" as const;

export interface AnchorRect {
  top: number;
  left: number;
  bottom: number;
  right: number;
  width: number;
  height: number;
}

export type InspectorMode = "inspector" | "create" | null;

export interface DocumentSmartTextInspectorState {
  activeFieldId: string | null;
  draftId: string | null;
  anchorRect: AnchorRect | null;
  mode: InspectorMode;
}
